module.exports = __webpack_public_path__ + "static/media/realtalk_sd_itsukif2d836e0897ea82902f301b4e6105c1c.webp";